<template>
  <section class="map">
    <div id="map"></div>
  </section>
</template>

<script>
import maps from '@/data/Maps'
import googleMaps from '@/utils/googleMaps'

export default {
  name: 'GoogleMap',
  props: {
    locations: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      maps,
      googleMaps,
      map: null,
      markers: []
    }
  },
  created() {
    // add google maps
    if (!window.google) {
      this.googleMaps.addGoogleMaps(this.maps.googleMapsAPIKey)
    }
  },
  mounted() {
    setTimeout(() => {
      var bounds = new google.maps.LatLngBounds();

      this.map = new window.google.maps.Map(
        document.querySelector('#map'), {
          center: {lat: -34.397, lng: 150.644},
          zoom: 6,
          mapTypeId: 'roadmap',
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: true,
          fullscreenControl: false
        }
      )

      var infowindow = new google.maps.InfoWindow()

      this.locations.forEach((item, index) => {
        let itemLat = Number(item.location.lat)
        let itemLng = Number(item.location.lng)

        let locationMarker = new window.google.maps.Marker({
          position: {lat: itemLat, lng: itemLng},
          map: this.map,
          icon: index === 0 ? this.getAltMapIcon() : this.getMapIcon()
        })

        bounds.extend(locationMarker.position);

        var content = `<div class="infowindow"><p class="ucase bold">${item.location_title}</p></div>`

        google.maps.event.addListener(locationMarker,'click', (function(locationMarker,content,infowindow){
          return function() {
            infowindow.setContent(content);
            infowindow.open(map,locationMarker);
          };
        })(locationMarker,content,infowindow))

        this.markers.push(locationMarker)
      })

      this.map.fitBounds(bounds);
    }, 800)
  },
  methods: {
    getMapIcon() {
      let iconWidth = this.windowWidth > 768 ? 50 : Math.round(50 * 0.66)
      let iconHeight = this.windowWidth > 768 ? 70 : Math.round(70 * 0.66)
      let icon = {
        url: `/images/icons/marker.png`,
        size: new window.google.maps.Size(iconWidth, iconHeight),
        scaledSize: new window.google.maps.Size(iconWidth, iconHeight),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(Math.round(iconWidth / 2), iconHeight)
      }
      return icon
    },
    getAltMapIcon() {
      let iconWidth = this.windowWidth > 768 ? 50 : Math.round(50 * 0.66)
      let iconHeight = this.windowWidth > 768 ? 70 : Math.round(70 * 0.66)
      let icon = {
        url: `/images/icons/markerNewActon.png`,
        size: new window.google.maps.Size(iconWidth, iconHeight),
        scaledSize: new window.google.maps.Size(iconWidth, iconHeight),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(Math.round(iconWidth / 2), iconHeight)
      }
      return icon
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  margin: $padding--base 0;
  position: relative;
  display: flex;

  #map {
    display: flex;
    margin: auto;
    width: 100%;
    max-width: 1130px;
    min-height: 35rem;
    max-height: 80vh;
  }
}
</style>

<style lang="scss">
  .infowindow {
    color: $color--base;
    max-width: 300px;
    text-align: center;
  }
</style>
